"use client";

import dynamic from "next/dynamic";

const HeadlessModeWarning = dynamic(() => import("./headless-mode-warning").then((mod) => mod.HeadlessModeWarning), { ssr: false });

export const LazyHeadlessModeWarning = () => <HeadlessModeWarning />;
